import { useEffect, useState } from "react";
import { useFetch } from "../../custom/api";
import PaymentFailure from "./components/paymentFailure";
import PaymentSuccess from "./components/paymentSuccess";
import VerifyProcess from "./components/verifyProcess";
import GoToTop from "../../components/GoToTop";


import { Link, useParams, useSearchParams } from "react-router-dom";

const VerifyPayment = () => {
  const { myFetch } = useFetch();
  let [searchParams, setSearchParams] = useSearchParams();
  let [paymentStatus, setPaymentStatus] = useState(null)

  let success = parseInt(searchParams.get('success'));
  const status = searchParams.get('status');
  let trackId = parseInt(searchParams.get('trackId'))
  if (!trackId) {
    trackId = parseInt(searchParams.get('token'))
  }
  if (!success) {
    success = status === 'done'
  }

  useEffect(() => {
    const fetchData = async () => {
      const data = {success, status, trackId}
      const resp = await myFetch(`verify-payment`, { method: "POST", body: JSON.stringify(data), headers: { "Content-Type": "application/json" }});
      const r = await resp.json();
      setPaymentStatus(r);
    };
    fetchData();
  }, []);

  return (
    <>
    {paymentStatus === null  && <VerifyProcess></VerifyProcess> }
    {paymentStatus !== null  && paymentStatus.status === "error" && <PaymentFailure trackId={trackId} message= {paymentStatus.message} ></PaymentFailure> }
    {paymentStatus !== null  && paymentStatus.status === "success" && <PaymentSuccess trackId={trackId}></PaymentSuccess> }
    {/* {success === 1 && <PaymentSuccess trackId={trackId}></PaymentSuccess>} */}
    {/* {success === 0 && <PaymentFailure trackId={trackId}></PaymentFailure>} */}
    <GoToTop />
    </>
  );
};

export default VerifyPayment;
